import { useEffect, useState } from 'react';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import ToastHost from '@/components/base/Toast';
import Hero from '@/pages/home/components/Hero';
import RankingBoard from '@/pages/home/components/RankingBoard';
import AlbumGrid from '@/pages/home/components/AlbumGrid';
import VideoSection from '@/pages/home/components/VideoSection';
import PhotoSetGrid from '@/pages/home/components/PhotoSetGrid';
import TagSection from '@/pages/home/components/TagSection';
import UpdateTimeline from '@/pages/home/components/UpdateTimeline';

function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) {
    return null;
  }

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className="fixed bottom-8 right-6 z-50 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 transition-colors duration-200 hover:bg-primary-600"
      aria-label="回到顶部"
    >
      <i className="ri-arrow-up-line text-xl" />
    </button>
  );
}

export default function Home() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <main className="w-full flex-1">
        <Hero />
        <RankingBoard />
        <AlbumGrid />
        <VideoSection />
        <PhotoSetGrid />
        <TagSection />
        <UpdateTimeline />
      </main>
      <SiteFooter />
      <BackToTop />
      <ToastHost />
    </div>
  );
}